import { Component, OnInit } from '@angular/core';
import { SEOService } from 'src/app/shared/seo.service';

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html'
})
export class ChangelogComponent implements OnInit {
  aktif = 'g1';
  bolumler = [
    { id: 'g1', baslik: '1 · Toplanan bilgiler' },
    { id: 'g2', baslik: '2 · Bilgilerin kullanımı' },
    { id: 'g3', baslik: '3 · Bilgilerin paylaşımı' },
    { id: 'g4', baslik: '4 · Saklama süresi' },
    { id: 'g5', baslik: '5 · Veri güvenliği' },
    { id: 'g6', baslik: '6 · Çerezler' },
    { id: 'g7', baslik: '7 · Haklarınız' },
    { id: 'g8', baslik: '8 · Değişiklikler' },
    { id: 'g9', baslik: '9 · İletişim' }
  ];

  constructor(private seoService: SEOService) {}

  ngOnInit(): void {
    this.setMeta();
  }

  git(event: Event, id: string) {
    event.preventDefault();
    this.aktif = id;
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  setMeta() {
    const title = 'pratiu - Gizlilik';
    this.seoService.updateDescription(title);
    this.seoService.updateKeywords('Gizlilik, gizlilik şartları');
    this.seoService.updateTitle(title);
  }
}
